define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"./_Store",
	"./_TableMixin"
], function(declare,Table,_Store,_TableMixin) {

	var	_ActionStore = declare(_Store, {
		typeSection: "Action",
		
		_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
			// summary: get resource for key from resolver
			return lr.getTypeAction(node.Type, node.Id);
		}
	});

	return declare([Table,_TableMixin], {
		storeClass: _ActionStore
	});
});